import * as types from "../actionTypes/catalogManagementUnitsAT";
import * as omnimap from "../../api/omnimap/omnimapApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function load(data) {
  return { type: types.LOAD_CATALOG_MANAGEMENT_UNITS_SUCCESS, data };
}

export function create(data) {
  return { type: types.CREATE_CATALOG_MANAGEMENT_UNITS_SUCCESS, data };
}

export function update(data) {
  return { type: types.UPDATE_CATALOG_MANAGEMENT_UNITS_SUCCESS, data };
}

export function deleteA(data) {
  return { type: types.DELETE_CATALOG_MANAGEMENT_UNITS_OPTIMISTIC, data };
}

export function SaveOrUpdate(model, method, id, token) {
  //eslint-disable-next-line no-unused-vars
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return omnimap
      .SaveOrEdit(model, method, id, token)
      .then((result) => {
        dispatch(update(result));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
